import { render, staticRenderFns } from "./PageFindCampus.vue?vue&type=template&id=0a8adada&"
import script from "./PageFindCampus.vue?vue&type=script&lang=js&"
export * from "./PageFindCampus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports